<template>
  <div class="xs:mb-2 xs:flex mb-4 gap-4 sm:block md:flex">
    <strong class="block basis-2/6 sm:block sm:w-full md:basis-4/12">
      {{ name }}
    </strong>

    <div
      class="flex w-full basis-4/6 items-center justify-between whitespace-pre-line text-[15px] md:basis-8/12"
    >
      <slot v-if="!editMode" />
      <div class="flex" v-else>
        <VSelect
          v-if="options"
          size="sm"
          class="mr-2 flex-1"
          :options="options"
          v-model="value"
        />
        <VInput
          v-else
          type="text"
          size="sm"
          class="mr-2 flex-1"
          v-model="value"
        />
        <Button
          size="sm"
          class="mr-px w-[40px]"
          :class="{ 'w-[90px]': loading }"
          @click="handleSave"
          :disabled="(!value && !allowEmpty) || loading"
          :loading="loading"
          loadingText="Saving"
        >
          ✓</Button
        >
        <Button
          v-if="!loading"
          size="sm"
          class="w-10"
          variant="destructive"
          @click="handleCancel"
          >x</Button
        >
      </div>
      <UIIconButton
        v-if="allowEdit"
        icon="PencilSquareIcon"
        @click="editMode = true"
      />
    </div>
  </div>
</template>

<script>
import { Button } from '@gpx-spa/ui';
import VInput from '../ui/VInput.vue';
import VSelect from '../ui/VSelect.vue';

export default {
  components: { VInput, VSelect, Button },

  emits: ['onSave', 'onCancel'],
  props: {
    name: {
      type: String,
      required: true,
    },
    editable: {
      type: [String, Number],
      required: false,
    },
    // Present: the row edits through a dropdown of these `{value, label}` rather than a
    // text field. The saved value is the option's own, so a non-numeric one survives
    // VSelect's numeric coercion.
    options: {
      type: Array,
      required: false,
    },
    loading: Boolean,
    allowEmpty: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      value: this.editable,
      editMode: false,
    };
  },

  computed: {
    allowEdit() {
      return (this.editable || this.editable === '') && !this.editMode;
    },
  },

  watch: {
    editable(newVal) {
      if (!this.editMode) {
        this.value = newVal;
      }
    },
    loading: {
      handler(n, o) {
        if (!n && o) {
          this.editMode = false;
        }
      },
    },
  },

  methods: {
    handleSave() {
      this.$emit('onSave', this.value);
    },
    handleCancel() {
      this.$emit('onCancel');
      this.editMode = false;
      this.value = this.editable;
    },
  },
};
</script>

<style></style>
